/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EMessageType {
  Email = 'Email',
  Sms = 'Sms'
}
